import create from 'zustand';

interface ChatSettingsState {
  selectedModelId: string | null;
  systemPrompt: string;
  temperature: number;
  topP: number;
  topK: number;
  contextSize: number;
  functionSupport: boolean;
  setSelectedModelId: (modelId: string | null) => void;
  setSystemPrompt: (prompt: string) => void;
  setTemperature: (value: number) => void;
  setTopP: (value: number) => void;
  setTopK: (value: number) => void;
  setContextSize: (value: number) => void;
  setFunctionSupport: (value: boolean) => void;
  applyBulk: (partial: Partial<Omit<ChatSettingsState,
    'setSelectedModelId' | 'setSystemPrompt' | 'setTemperature' | 'setTopP' | 'setTopK' | 'setContextSize' | 'setFunctionSupport' | 'applyBulk'>>) => void;
}

export const useChatSettingsStore = create<ChatSettingsState>((set) => ({
  selectedModelId: null,
  systemPrompt: '',
  temperature: 0.7,
  topP: 0.9,
  topK: 40,
  contextSize: 8128,
  functionSupport: false,
  setSelectedModelId: (modelId) => set({ selectedModelId: modelId }),
  setSystemPrompt: (systemPrompt) => set({ systemPrompt }),
  setTemperature: (temperature) => set({ temperature }),
  setTopP: (topP) => set({ topP }),
  setTopK: (topK) => set({ topK }),
  setContextSize: (contextSize) => set({ contextSize }),
  setFunctionSupport: (functionSupport) => set({ functionSupport }),
  applyBulk: (partial) => set(partial as any),
}));


